// Memorable hut-duty login aliases. Used by:
//   - the server to auto-generate aliases when a roster entry is created
//     or imported without one, and during the one-shot backfill of legacy
//     rows that pre-date the `login_alias` column,
//   - the admin UI to suggest a candidate alongside the manual input
//     (the server's unique index is the ultimate authority on conflicts).
//
// Umlauts are spelled out (`saentis`, `baechli`, `laerche`, …) so an iOS
// keyboard doesn't auto-suggest the umlaut form and corrupt the typed
// login.

export const ALIAS_WORDS = [
  'alpenrose',
  'edelweiss',
  'enzian',
  'tannenwald',
  'bergweide',
  'gletscher',
  'felshorn',
  'gipfel',
  'matterhorn',
  'eiger',
  'jungfrau',
  'rigi',
  'titlis',
  'pilatus',
  'saentis',
  'baechli',
  'wasserfall',
  'brunnen',
  'fontaene',
  'quelle',
  'laerche',
  'tanne',
  'ahorn',
  'buche',
  'eiche',
  'fuechsli',
  'murmeltier',
  'steinbock',
  'gaemse',
  'adler',
] as const;

export const ALIAS_RE = /^[a-z]+-\d{2}$/;

/** Pick a random candidate of the shape `word-NN`. Uniqueness is the
 * caller's responsibility (server has a partial unique index that's the
 * final authority). */
export function randomAlias(): string {
  const word = ALIAS_WORDS[Math.floor(Math.random() * ALIAS_WORDS.length)]!;
  const suffix = String(Math.floor(Math.random() * 100)).padStart(2, '0');
  return `${word}-${suffix}`;
}
